import React, { useContext, useEffect, useState } from 'react';
import UploadPhoto from '../Gallery/UploadPhoto';
import { Context } from "../contexts/AppContext";
import ProgressBar from './ProgressBar';
import { postData } from "../../lib/utils";
import VideoThumbnail from './VideoThumbnail';
import StudioHeader from './StudioHeader';
import PhotoHeader from '../PropertyList/PhotoHeader';
import PhotoThumbnail from './PhotoThumbnail';

function PhotoManager() {
  const { value, progress } = useContext(Context);
  const [appState, setAppState] = value;
  const { currentFolderName, currentGalleryName, currentGalleryId, currentDBGalleryId } = appState;

  const [modalOpen, setModalOpen] = useState(appState.modalData);
  const { files = [], startProgress, updateProgress, stopProgress } = progress;

  const [fileName, setFileName] = useState("");
  const [prgBarVal, setPrgVal] = useState(0);
  const [showPrgComp, setShowPrgComp] = useState(false);
  const [dataLoad, setDataLoaded] = useState(false);

  const videoLen = appState?.photoArr?.length || 0;

  useEffect(() => {
    setModalOpen(appState.modalData);
  }, [appState.modalData]);

  useEffect(() => {
    console.log("PHOTOOOOOOOOOO ARR ",appState?.photoArr)
    // Mark data loaded once photoArr is available
    if (appState.photoArr) {
      setDataLoaded(true);
    }
  }, [appState.photoArr]);

  const showProgressBar = (fileName, value) => {
    startProgress(fileName);
    updateProgress(value);
  };

  const photoUploadedDone = async (fileName) => {

    
    
    const response = await postData("photos/createPhoto", {
      title: fileName.name,//.split(".")[0],
      url: `${appState.currentFolderData.name}/${currentGalleryName}/${fileName.name}`,
      galleryId: appState.currentGalleryData._id
    });

    if (response) {
      setAppState((prevState) => ({
        ...prevState,
        photoArr: [...prevState.photoArr, response],
      }));

      setShowPrgComp(false);
      stopProgress();
    }
  };

  return (
    <div>
      <PhotoHeader />

      {!dataLoad ? (
        <div className="absolute h-screen flex flex-col justify-center mx-auto w-full items-center border">
          <h2 className="p-4 font-bold">Loading Photos...</h2>
        </div>
      ) : (
        <>
          {files.length <= 0 && videoLen <= 0 && (
            <div className="absolute h-screen flex flex-col justify-center mx-auto w-full items-center border">
              <h2 className="p-4 font-bold">No Photos added yet</h2>
                {/* <UploadPhoto showProgressBar={showProgressBar} photoUploadedDone={photoUploadedDone} /> */}

                    <p className="text-center text-black text-xl max-w-md px-4">
      Drag & drop a folder for bulk photo uploads, or use the
      <strong> Upload Photos </strong>
      button to select and upload images from your device.
    </p>

                
            </div>
          )}

          {showPrgComp && (
            <ProgressBar id="prgbar" fileName={fileName} prgBarVal={prgBarVal} />
          )}

          {!showPrgComp && videoLen > 0 && (
            <PhotoThumbnail />
          )}
        </>
      )}
    </div>
  );
}

export default PhotoManager;
